import { render, staticRenderFns } from "./ZXKFEdit.vue?vue&type=template&id=0364e7ba&scoped=true"
import script from "./ZXKFEdit.vue?vue&type=script&lang=js"
export * from "./ZXKFEdit.vue?vue&type=script&lang=js"
import style0 from "./ZXKFEdit.vue?vue&type=style&index=0&id=0364e7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0364e7ba",
  null
  
)

export default component.exports